import { useCallback, useRef } from 'react';

export type IEnqueue = <TResult>(task: () => Promise<TResult>) => Promise<TResult>;

const ignoreOutcome = (): void => undefined;

export const useSerialQueue = (): IEnqueue => {
  const tail = useRef<Promise<unknown>>(Promise.resolve());

  return useCallback<IEnqueue>(<TResult>(task: () => Promise<TResult>): Promise<TResult> => {
    const result = tail.current.then(task);
    tail.current = result.then(ignoreOutcome, ignoreOutcome);

    return result;
  }, []);
};
